import AccordionList from "@/components/accordionList";
import { FAQ_LIST } from "./constants";

const FaqComponent = () => {
  return <AccordionList {...FAQ_LIST} />;
};

export default FaqComponent;
